import { calculatePrice } from './engine';
import { isOrderPageData } from '../types';
import type { DepositInfo, DepositInfoProps } from './types';
import type { Currency } from '../../../api';

/**
 * What the customer pays up front: a fixed amount per person on the order page, or a percentage of
 * the price on the account. The percentage path skips custom lines — add-ons are paid at the venue.
 */
export const getDepositInfo = ({
  widgetOrderPageData,
  details,
  dateDetails,
  account,
}: DepositInfoProps): DepositInfo | null => {
  // A pass carries a single numeric price and has no deposit concept.
  if (!isOrderPageData(widgetOrderPageData)) {
    return null;
  }
  if (widgetOrderPageData.deposit_amount_per_person != null) {
    const persons = details.persons || 1;
    return {
      amount: widgetOrderPageData.deposit_amount_per_person * persons,
      currency: (widgetOrderPageData.deposit_currency as Currency) || account.currency,
    };
  }
  if (account.deposit_percentage) {
    const price = calculatePrice(widgetOrderPageData, details, dateDetails, {
      depositPercentage: account.deposit_percentage,
      holidayCalendar: account.holiday_calendar,
    });
    return { amount: price, currency: account.currency };
  }
  return null;
};
